import * as Sentry from '@sentry/react';
const captureError = ({ name, error, country, data, user, }) => {
    Sentry.withScope((scope) => {
        if (user) {
            scope.setUser(user);
        }
        scope.setTags({
            name,
            country,
        });
        scope.setExtra('data', JSON.stringify(data));
        scope.setLevel('error');
        Sentry.captureException(error);
    });
};
export const observabilityService = {
    captureError,
};
